import { useState } from "react";
import { IoAddOutline, IoDocumentOutline } from "react-icons/io5";
import Modal from "../../../../components/common/Modal";
import TextboxSearch from "./../../../../components/common/TextboxSearch";
import ContributionForm from "./components/ContributionForm";
import ContributionsTable from "./components/ContributionsTable";

const Contributions = ({ id, onRefresh }) => {
  const [contributions, setContributions] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [tableOptions, setTableOptions] = useState({
    search_query: "",
    current_page: 1,
    page_size: 10,
    sort_column: { path: "date_contributed", order: "desc" },
  });

  const columns = [
    { path: "transaction_id", label: "No." },
    { path: "contribution_type_name", label: "Contribution" },
    { path: "amount", label: "Amount" },
    { path: "period", label: "Period" },
    { path: "date_contributed", label: "Date Contributed" },
    {
      key: "actions",
      content: (data) => {
        if (!data.s3_reference_name) return;

        return (
          <a
            className="hover:text-blue-400"
            href={data.s3_reference_name}
            rel="noreferrer"
            target="_blank"
            title="View Document"
          >
            <IoDocumentOutline />
          </a>
        );
      },
    },
  ];

  const handleOptionsChange = (options) => setTableOptions(options);

  const handleSearch = (query) => {
    const options = { ...tableOptions };

    if (options.search_query !== query) {
      options.search_query = query;
      options.current_page = 1;
      handleOptionsChange(options);
    }
  };

  const handleSuccess = () => {
    const options = { ...tableOptions };
    setTableOptions(options);
    setShowForm(false);
    onRefresh();
  };

  return (
    <div className="card p-8">
      <div className="block sm:flex justify-between items-center">
        <div>
          <p className="text-gray-400 text-sm">Contribution Management</p>
          <span className="text-gray-400 text-xs">List of Contributions</span>
        </div>
        <div className="mt-5 sm:mt-0">
          <button
            className="button button-primary"
            onClick={() => setShowForm(true)}
          >
            <IoAddOutline className="mr-2" />
            Create Contribution
          </button>
        </div>
      </div>
      <div className="block sm:justify-between items-center mt-8">
        <TextboxSearch placeholder="Search..." onSearch={handleSearch} />
      </div>
      <div className="mt-8">
        <ContributionsTable
          id={id}
          columns={columns}
          data={contributions}
          tableOptions={tableOptions}
          setData={setContributions}
          onChange={handleOptionsChange}
        />
      </div>
      <Modal
        size="md"
        title="Create Contribution"
        isOpen={showForm}
        onClose={() => setShowForm(false)}
        borderTop
      >
        <ContributionForm
          id={id}
          isLoading={isLoading}
          setLoading={setIsLoading}
          onSuccess={handleSuccess}
        />
      </Modal>
    </div>
  );
};

export default Contributions;
